import Link from 'next/link'
import { ArrowRight, Lock } from 'lucide-react'

// The pieces every client card is built from: the client's live homepage in
// a browser frame and their logo. No 'use client', so the server-rendered
// pages (/clients, /clients/<slug>) ship no JS for them.
//
// The screenshot opens the client's case study (`href`) when there is one;
// only the "View website" button goes to the client's own site (owner,
// 2026-11-04). Without a case study it is not a link.

export function ClientBrowser({ card, href, eager = false }) {
  if (!card.shot) return null
  const frame = (
    <>
      <span className="cl-browser-bar" aria-hidden="true">
        <span className="cl-dots"><i /><i /><i /></span>
        <span className="cl-address"><Lock size={10} strokeWidth={2.5} />{card.host}</span>
      </span>
      <img
        className="cl-shot"
        src={card.shot.src}
        width={card.shot.width}
        height={card.shot.height}
        alt={`${card.name} website homepage`}
        loading={eager ? 'eager' : 'lazy'}
        fetchPriority={eager ? 'high' : undefined}
        decoding="async"
      />
    </>
  )
  if (!href) return <div className="cl-browser">{frame}</div>
  return (
    <Link className="cl-browser" href={href} aria-label={`Read the ${card.name} case study`}>
      {frame}
      <span className="cl-browser-cta" aria-hidden="true">Read the case study <ArrowRight size={13} /></span>
    </Link>
  )
}

export function ClientLogo({ card }) {
  if (!card.logo) return null
  return (
    <span className={`cl-logo${card.logo.dark ? ' is-dark' : ''}`}>
      <img src={card.logo.src} width={card.logo.width} height={card.logo.height} alt={`${card.name} logo`} loading="lazy" decoding="async" />
    </span>
  )
}
